import { mapToMediaModel, MediaModel } from './conversations';
import Config from '../config';
export class AutoAlertKeywordModel {
    constructor() { }
    ID: string;
    Keyword: string;
    PhoneNumberID: string;
    Status: AutoAlertKeyStatus;
    CreatedBy: string | null;
    CreatedDateTime: string;
    IsDeleted: boolean;
}

export const mapToAutoAlertKeyword = (x: any): AutoAlertKeywordModel => {
    return {
        ID: x.id,
        Keyword: x.keyword,
        PhoneNumberID: x.phoneNumberId,
        Status: x.status as AutoAlertKeyStatus,
        CreatedBy: x.createdBy,
        CreatedDateTime: x.createdDateTime,
        IsDeleted: x.isDeleted
    } as AutoAlertKeywordModel;
}

export class AutoAlertLogsModel {
    constructor() { }
    Number: string;
    CreatedDateTime: string;
    IsSuccess: boolean;
    RuleID: string;
    Keyword: string;
}

export const mapToAutoAlertLogs = (x: any): AutoAlertLogsModel => {
    return {
        Number: x.number,
        CreatedDateTime: x.createdDateTime,
        IsSuccess: x.isSuccess,
        RuleID: x.ruleId,
        Keyword: x.keyword
    } as AutoAlertLogsModel;
}

export class RuleModel {
    constructor() { }
    ID: string;
    Name: string;
    Type: RuleType;
    // KeywordID: string;
    // Priority: number;
    Status: RuleStatus;
    Message: string;
    IsOneTime: boolean;
    Duration: RuleDuration;
    PhoneNumbers: string[];
    ParentRuleId: string;
    CreatedBy: string;
    CreatedDateTime: string;
    IsLiveToday: boolean;
    Media?: MediaModel[];
    IsDeleted: boolean;
    Keyword: string;
    IsKeyWordOptIn: boolean;
}

export class RuleDuration {
    constructor() {
    }
    DurationType: RuleDurationType;
    StartDateTime: number;
    EndDateTime: number;
    Days: RuleDurationDays[];
}

export const mapToRuleDuration = (x: any): RuleDuration => {
    return {
        DurationType: x.durationType as RuleDurationType,
        StartDateTime: x.startDateTime,
        EndDateTime: x.endDateTime,
        Days: x.days
    } as RuleDuration;
}

export const serializeRuleDuration = (x: RuleDuration): any => {
    return {
        durationType: x.DurationType,
        startDateTime: new Date(x.StartDateTime).toISOString(),
        endDateTime: new Date(x.EndDateTime).toISOString(),
        days: x.Days
    } as any;
}

export const mapToAutoAlertRule = (x: any): RuleModel => {
    return {
        ID: x.id,
        Name: x.name,
        Type: x.type as RuleType,
        // KeywordID: x.keywordId,
        // Priority: x.status === RuleStatus.COMPLETED ? NaN : x.priority,
        Status: x.status as RuleStatus,
        Message: x.message,
        IsOneTime: !x.isRecurring,
        Duration: x.duration ? mapToRuleDuration(x.duration) : undefined,
        PhoneNumbers: x.phoneNumberList,
        ParentRuleId: x.parentRuleId,
        CreatedBy: x.createdBy,
        CreatedDateTime: x.createdDateTime,
        IsLiveToday: x.isLiveToday,
        IsDeleted: x.isDeleted,
        Media: !!x.media?.length ? x.media.map(mapToMediaModel) : [],
        Keyword: x.keyword,
        IsKeyWordOptIn: x?.isKeywordOptIn
    } as RuleModel;
}

export const serializeAutoAlertRule = (x: RuleModel): any => {
    return {
        id: x.ID,
        name: x.Name,
        type: x.Type,
        status: x.Status,
        message: x.Message,
        isRecurring: !x.IsOneTime,
        duration: x.Duration ? serializeRuleDuration(x.Duration) : null,
        phoneNumberList: x.PhoneNumbers || [],
        parentRuleId: x.ParentRuleId,
        createdBy: x.CreatedBy,
        createdDateTime: x.CreatedDateTime,
        isLiveToday: x.IsLiveToday,
        isDeleted: x.IsDeleted,
        media: x.Media,
        Keyword: x?.Keyword,
        isKeyWordOptIn: x?.IsKeyWordOptIn
    } as any;
}

export enum RuleDurationDays {
    SUNDAY,
    MONDAY,
    TUESDAY,
    WEDNESDAY,
    THURSDAY,
    FRIDAY,
    SATURDAY,

}

export enum AutoAlertKeyStatus {
    ACTIVE,
    PAUSED
}

export enum RuleStatus {
    ACTIVE,
    INACTIVE,
    COMPLETED
}

export enum RuleType {
    AUTO_REPLY,
    KEYWORD
}

export enum RuleDurationType {
    FIXED_DURATION,
    REPEAT_DAILY,
    REPEAT_WEEKLY,
    REPEAT_MONTHLY,
    ALWAYS,
}
